export const firebaseConfig = {
    apiKey: "AIzaSyCzZizfGDYCgqK7ZjCL0-VEjGmvEZNYR2w",
    authDomain: "skyvisor-admin.firebaseapp.com",
    databaseURL: "https://skyvisor-admin-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "skyvisor-admin",
    storageBucket: "skyvisor-admin.appspot.com",
    messagingSenderId: "1011779385582",
    appId: "1:1011779385582:web:6d0e79a256379673149bff",
    measurementId: "G-PSJT2WB3J2"
  };